export default "__VITE_ASSET__cfb5d254__"